import React from 'react';
import Box from '@mui/material/Box';
import { dsV2 } from '@bloomays-lib/ui.shared';

export type KpiAccent = 'vert' | 'bleu' | 'noir' | 'solaire' | '';

/** Carte KPI (`.kpi`) avec barre d'accent colorée en pied. */
export const KpiCard = ({
  label,
  value,
  sub,
  accent = '',
}: {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  accent?: KpiAccent;
}) => {
  const barColor =
    accent === 'vert'
      ? dsV2.color.vert
      : accent === 'bleu'
      ? dsV2.color.bleu
      : accent === 'noir'
      ? dsV2.color.noir
      : accent === 'solaire'
      ? dsV2.color.solaire
      : dsV2.color.border;
  const valueColor =
    accent === 'vert'
      ? dsV2.color.vert
      : accent === 'bleu'
      ? dsV2.color.bleu
      : accent === 'solaire'
      ? dsV2.color.solaireText
      : dsV2.color.noir;
  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: dsV2.color.blanc,
        border: `1px solid ${dsV2.color.border}`,
        borderRadius: dsV2.radius.lg,
        boxShadow: dsV2.shadow.sm,
        padding: '15px 17px 18px',
        transition: 'box-shadow .2s',
        '&:hover': { boxShadow: dsV2.shadow.hover },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 14,
          right: 14,
          height: 3,
          borderRadius: '3px 3px 0 0',
          backgroundColor: barColor,
        },
      }}
    >
      <Box
        sx={{
          fontSize: 10,
          fontWeight: 600,
          color: dsV2.color.t4,
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          marginBottom: '6px',
        }}
      >
        {label}
      </Box>
      <Box
        sx={{
          fontFamily: dsV2.font.sansBold,
          fontVariantNumeric: 'tabular-nums',
          fontSize: '1.35rem',
          fontWeight: 700,
          lineHeight: 1,
          letterSpacing: '-0.02em',
          marginBottom: '3px',
          color: valueColor,
        }}
      >
        {value}
      </Box>
      {sub ? <Box sx={{ fontSize: '10.5px', color: dsV2.color.t4 }}>{sub}</Box> : null}
    </Box>
  );
};
